import { useCallback, useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { api, coachHeaders, formatDateHeure } from "../lib/api";

export const SecurityAlert = ({ code, onVoir }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/alertes", coachHeaders(code)).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, [code]);
  useEffect(() => { load(); }, [load]);
  if (rows.length === 0) return null;
  const vu = async () => {
    try { await api.post("/admin/alertes/vu", {}, coachHeaders(code)); setRows([]); } catch { /* reste affichée */ }
  };
  const n = rows.length;
  return (
    <div data-testid="security-alert" role="alert" className="mt-4 rounded-2xl border-2 border-signal bg-signal/20 p-4 text-chalk">
      <p className="flex items-center gap-2 font-display text-xl uppercase text-signal"><ShieldAlert className="h-6 w-6 shrink-0" />Alerte sécurité</p>
      <p className="mt-1 text-sm">{n} appareil{n > 1 ? "s ont" : " a"} été bloqué{n > 1 ? "s" : ""} après 3 codes faux depuis ta dernière visite.</p>
      <ul className="mt-2 space-y-1">
        {rows.slice(0, 5).map((a, i) => (
          <li key={`${a.date}-${i}`} data-testid="security-alert-row" className="font-mono text-xs">{formatDateHeure(a.date)} · {a.appareil || "?"} · IP {a.ip}</li>
        ))}
      </ul>
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid="security-alert-voir" onClick={onVoir} className="rounded-full bg-signal px-4 py-2 text-sm font-semibold text-ink">Voir le journal</button>
        <button data-testid="security-alert-vu" onClick={vu} className="rounded-full border border-chalk/50 px-4 py-2 text-sm text-chalk hover:border-chalk">J'ai vu</button>
      </div>
    </div>
  );
};
